module.exports = __webpack_public_path__ + "img/Water_1_M_Normal.a33d50da.jpg";